import { render, staticRenderFns } from "./IconChapters.vue?vue&type=template&id=351c9a0c&"
import script from "./IconChapters.vue?vue&type=script&lang=js&"
export * from "./IconChapters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('351c9a0c')) {
      api.createRecord('351c9a0c', component.options)
    } else {
      api.reload('351c9a0c', component.options)
    }
    module.hot.accept("./IconChapters.vue?vue&type=template&id=351c9a0c&", function () {
      api.rerender('351c9a0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconChapters.vue"
export default component.exports